import { SearchDemo } from "./SearchDemo"

# @startpage / search

Provides a function to search the web.

## performSearch

Function to perform a web search.

### API

#### Args

| name    | type                           | description                                                                                                                                       |
| ------- | ------------------------------ | ------------------------------------------------------------------------------------------------------------------------------------------------- |
| query   | string                         | Query of the search                                                                                                                               |
| engine  | SearchEngineName               | Engine which will be used to search. Can be one of the following:<br/>"deepl" \| "duckduckgo" \| "ecosia" \| "google" \| "startpage" \| "youtube" |
| options | SearchOptions<br/>\| undefined | Search options regarding the redirection                                                                                                          |

#### SearchOptions

| name             | type                   | description                                             |
| ---------------- | ---------------------- | ------------------------------------------------------- |
| newTab           | boolean                | Query will get opened in new tab                        |
| directLink       | boolean                | If the query is an url, the url will be opened directly |
| forwardingLookup | Record<string, string> | Lookup which specifies forwarding for defined queries   |

### Example

<SearchDemo />

```
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { performSearch } from "@startpage/search"

const settings = {
  newTab: true,
  directLink: true,
  forwardingLookup: {
    "absolute bangers":
      "https://www.youtube.com/playlist?list=PL0YDkBQVcBrrTJfTApkmx3L_19QNS4nC8"
  }
}

export const SearchDemo = () => {
  const [value, setValue] = useState("")

  const search = () => performSearch(value, "duckduckgo", settings)

  return <RowLayout>
    <input
      type="text"
      placeholder="Search the web"
      value={value}
      onChange={setValue}
    />
    <button onClick={search}>
      <FontAwesomeIcon icon={faSearch} />
    </button>
  </RowLayout>
}
```
